function formatErrors(errorsObject) {
    const errors = Object.entries(errorsObject).map(
        ([errorType, errorsList]) => `${errorType}:${errorsList[0]}`,
    );

    return errors;
}

export default function prepareErrors(xhr) {
    return new Promise(resolve => {
        let errors = [];

        if (xhr.status === 401) {
            return window.location.reload(true);
        }

        if ([500, 502].includes(xhr.status)) {
            errors = ['server_error'];
            return resolve({ errors });
        }

        let errorData;

        try {
            errorData = JSON.parse(xhr.responseText);
            if (!errorData || typeof errorData !== 'object') {
                errorData = {};
            }
        } catch (err) {
            errorData = {};
        }

        const errorsExtras = {
            ...(errorData.errors_extras || {}),
            ...(errorData.extras || {})
        };
        const redirectUrl = errorsExtras.redirect_url;

        if (redirectUrl) {
            window.location.href = redirectUrl;
            return null;
        }

        if (errorData.errors) {
            if (
                errorData.errors.__all__.length > 0
                && errorData.errors.__all__.includes('already_authenticated')
                && xhr.status === 409
            ) {
                window.location.href = window.Settings.Authentication.LoginUrl;
            }

            if (errorData.extras) {
                if (errorData.extras.reload) {
                    return window.location.reload(true);
                }

                if (errorData.extras.banned_until) {
                    errors = formatErrors(errorData.errors);
                } else {
                    errors = Object.values(errorData.errors).map(error => {
                        const extra = Object.values(errorData.extras)[0];

                        return `${extra}:${error[0]}`;
                    });
                }
            } else {
                errors = formatErrors(errorData.errors);
            }
        } else if (errorData.errors_codes) {
            if (errorData.errors_codes.__all__) {
                errors = errorData.errors_codes.__all__.map(error => `__all__:${error}`);
            } else {
                errors = formatErrors(errorData.errors_codes);
            }
        }

        return resolve({ errors, errorsExtras });
    });
}
